import React, { useEffect, useState } from 'react';
import { getTicketDetailAPI } from '@/service/ticketService';
import { API } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import { MenuItem } from '@material-ui/core';
import OverFlowTooltipWithTabsMui from '../../common/OverFlowTooltipWithTabsMui';
import { Skeleton } from '@material-ui/lab';

export default function RenderTagItemSingleChoice({ item, className, name, id, isTagMaster, onClick }) {
    const [itemLabel , setItemLabel] = useState(name);
    const [loading , setLoading] = useState(false);
    
    useEffect(() => {
        if (!isTagMaster) return;
        if(!itemLabel) {
            setLoading(true);
            getTicketDetailAPI(API, id).then((ticketDetailResult) => {
                let detailTicket = ticketDetailResult.detailTicket;
                let titketTitle =  Utils.getTitle(detailTicket?.settingTitle);
                setLoading(false);
                setItemLabel(titketTitle);
            })
        }
    }, [item]);

    return (
        <MenuItem
            key={id}
            value={id}
            onClick={e => onClick(item)}
            className={className}
        >
            <OverFlowTooltipWithTabsMui value={loading ? <Skeleton variant="text" width={200} height={30} /> : itemLabel}/>
        </MenuItem>
    );
}